<!--
 * @Author: Merlin
 * @Date: 2024-12-10 11:29:59
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-12 18:53:22
 * @Description: 
-->
<template>
    <q-menu
        v-if="input"
        :target="input"
        :offset="[70, 0]"
        :style="{ 'background': 'transparent', 'box-shadow': 'none' }"
        v-model="visibleConotrol"
        aaa_max-width="220px"
        max-height="160px"
        anchor="top left"
        self="bottom left"
    >
        <div class="pb-5">
            <ul class="popper-content">
                <li
                    v-for="(cur, idx) of aChipsInUse"
                    :key="idx"
                    class="one-chip"
                    :style="{
                        'background-image': `url(${cur.img})`,
                    }"
                    @click="onChipClick(cur)"
                >
                    {{
                        cur.name ||
                        (cur.value >= 1_000 ? (cur.value / 1_000).toFixed(0) + 'K' : cur.value)
                    }}
                </li>
            </ul>
        </div>
    </q-menu>
</template>

<script lang="ts" setup>
import { onMounted, computed, ref, nextTick } from 'vue';
import c1 from '@/assets/imgs/chips/c01.png';
import c10 from '@/assets/imgs/chips/c02.png';
import c100 from '@/assets/imgs/chips/c03.png';
import c1k from '@/assets/imgs/chips/c04.png';
import c10k from '@/assets/imgs/chips/c05.png';
import c100k from '@/assets/imgs/chips/c06.png';
// -------- ↑ 筹码表 -----------------------------------
import { useJoinStateStore } from '~/stores/cansino/joinState';
import betHelper from '~/common/js/betHelper';
import { useConfig } from '@/socket/config/index';
import useSettingsStore from '@/stores/settings';
import useGlobalStore from '@/stores/global';

const props = defineProps({
    // gameName: { type: String, default: '', },
    modelValue: {
        type: [String, Number], // 补一个 Number, 否则在 circle 游戏中会触发在控制台不停打印
    },
    amountSetter: {
        type: Function,
    },
    input: {
        type: [Object, null], // 输入框的 dom
        required: true, // 必须传入，用于取消默认的 focus 事件，
    },
    disabled: {
        type: Boolean,
    },
    // Circle游戏使用
    currentFormOption: {
        type: [Object, null],
        default: () => ({}),
        required: false,
    },
});

const { GET_CHIPS_CONFIG } = useConfig();
const { t: $tFn } = useNuxtApp().$i18n;
const oUserStore = useSettingsStore();
const globalStore = useGlobalStore();
const emit = defineEmits(['update:modelValue']);

// ↓ 筹码列表
const aChipList = [
    {
        img: c1,
        value: 0, // ← 此值将从后端取值
    },
    {
        img: c10,
        value: 0,
    },
    {
        img: c100,
        value: 0,
    },
    {
        img: c1k,
        value: 0,
    },
    {
        img: c10k,
        value: 0,
    },
    {
        img: c100k,
        name: $tFn('customAmount'),
        custom: true, // 当前项不参与过滤，始终显示
    },
];

const isShowChipList = ref(false);
const visibleConotrol = computed({
    get() {
        if (props.disabled) {
            return false; // 不显示
        }
        return isShowChipList.value;
    },
    set(newVal) {
        // console.log("气泡可见性：", newVal);
        if (newVal) {
            props.input?.blur(); // 不要选中
        }
        isShowChipList.value = !!newVal;
    },
});

const aChipsInUse = computed(() => {
    let iMax = 0;
    const aConfig = globalStore.chipsConfig[oUserStore.pickedCurrency] || [];

    if (props.currentFormOption) {
        iMax = betHelper.getMaxBetAmout(1, props.currentFormOption.key);
    } else {
        iMax = betHelper.getMaxBetAmout();
    }
    const aResult = aChipList
        .map((cur, idx) => {
            return {
                ...cur,
                value: aConfig[idx] || 0,
            };
        })
        .filter((cur) => {
            return cur.custom || (cur.value > 0 && cur.value <= iMax);
        });
    return aResult;
});

const onChipClick = async (oChip) => {
    isShowChipList.value = false; // 关闭气泡
    await nextTick();
    if (!oChip.value) {
        toFocus();
        return; // 终止在此
    }
    // -- ↓ 赋值 --------------------------------
    if (props.amountSetter) {
        props.amountSetter(oChip.value);
    } else {
        emit('update:modelValue', Number(oChip.value).toFixed(2));
    }
};

const toFocus = () => {
    const oInput = props.input;
    if (!oInput) return;
    oInput.focus();
    oInput.select();
};
/**
 * 获取筹码金额表
 */
const handleGetChipsConfig = async () => {
    // ↓ 防止重复查询 
    if (Object.keys(globalStore.chipsConfig || {}).length) {
        return;
    }
    const data = await GET_CHIPS_CONFIG();
    if ((data as any)?.chipsConfig) {
        globalStore.setState({
            chipsConfig: data['chipsConfig'],
        });
    }
    console.log("快捷筹码查询完毕，如下：\n", deepCopy(globalStore.chipsConfig));
}

onMounted(() => {
    handleGetChipsConfig();
});
</script>

<style scoped lang="scss">
.popper-content {
    min-width: 200px;
    --bg-color: #283343;
    display: flex;
    flex-flow: row nowrap;
    background: var(--bg-color);
    padding: 5px 8px;
    border-radius: 8px;
    position: relative;
    filter: drop-shadow(2px 2px 3px black);
    &:after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        left: 55px;
        bottom: -16px;
        border-style: solid;
        border-width: 18px 12px 0;
        border-color: var(--bg-color) transparent transparent transparent;
    }
    .one-chip {
        width: 43px;
        height: 43px;
        line-height: 43px;
        text-align: center;
        color: black;
        font-weight: bold;
        font-size: 14px;
        background-size: 100% 100%;
        letter-spacing: -0.5px;
        cursor: pointer;
        + .one-chip {
            margin-left: 9px;
        }
    }
}
</style>


